<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container my-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>   <m-products-308 v-bind='{...{"paginate":"true","perPage":12,"productCardName":"mProductCard505","showSpecifiedCardFeature":"","cardWrapperCLass":""},...{}}' :style='""' class="" ></m-products-308></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-shopping-cart-2 v-bind='{...{"haveItem":"https:\/\/api.mizline.ir\/storage\/contents\/shopping-cart-icon-512x462-yrde1eu0.png","empty":"https:\/\/api.mizline.ir\/storage\/contents\/shopping-cart-icon-512x462-yrde1eu0.png"},...{}}' :style='"\n"' class="sticky-shopping" ></m-shopping-cart-2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mProducts308 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products308/Products308'; import mShoppingCart2 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/ShoppingCart2';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mProducts308,mShoppingCart2 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
